export default "__VITE_ASSET__B77JH4q5__"